module.exports = __webpack_public_path__ + "img/sk-partners-startitup.2a79121c.png";